import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function ProofSection() {
  const ref = useScrollReveal();
  return <section ref={ref} className="w-full section-padding" style={{
    backgroundColor: '#faf7f2'
  }} aria-label="Proof and believability" data-id="element-245">
      <div className="max-w-3xl mx-auto text-center" data-id="element-246">
        {/* Label */}
        <div className="scroll-reveal mb-8" data-id="element-247">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase px-3 py-1.5 rounded-full" style={{
          color: '#c9a96e',
          backgroundColor: 'rgba(201,169,110,0.12)',
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-248">
            Why It Works
          </span>
        </div>

        {/* Big stat */}
        <div className="scroll-reveal scroll-reveal-delay-1 mb-6" data-id="element-249">
          <p className="text-7xl md:text-8xl font-black" style={{
          fontFamily: "'Playfair Display', serif",
          color: '#1a2744'
        }} aria-label="70 percent" data-id="element-250">
            70
            <span style={{
            color: '#c9a96e'
          }} data-id="element-251">
              %
            </span>
          </p>
          <p className="text-lg md:text-xl font-medium mt-2" style={{
          color: '#4a4540',
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-252">
            reduction in night-resistance by the end of Night 2.
          </p>
        </div>

        <div className="scroll-reveal scroll-reveal-delay-2 gold-divider mb-10" data-id="element-253" />

        {/* Explanation */}
        <div className="scroll-reveal scroll-reveal-delay-3 mb-12" data-id="element-254">
          <p className="text-base md:text-lg leading-relaxed" style={{
          color: '#4a4540',
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-255">
            Because this method relies on Circadian rhythms — the same biology
            that governs every human being on earth — the results are{' '}
            <strong style={{
            color: '#1a2744'
          }} data-id="element-256">
              mechanical.
            </strong>{' '}
            Once the adrenaline tank is emptied and the melatonin anchor is set,
            the brain has no biological choice but to drop into sleep.
          </p>
        </div>

        {/* Trust badges */}
        <div className="scroll-reveal scroll-reveal-delay-4 grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-257">
          <div className="rounded-xl p-4 text-center" style={{
          backgroundColor: '#ffffff',
          border: '1px solid rgba(201,169,110,0.15)',
          boxShadow: '0 2px 8px rgba(26,39,68,0.05)'
        }} data-id="element-258">
            <p className="text-2xl font-bold mb-1" style={{
            fontFamily: "'Playfair Display', serif",
            color: '#1a2744'
          }} data-id="element-259">
              72 hrs
            </p>
            <p className="text-xs" style={{
            color: '#6b6560',
            fontFamily: "'Inter', sans-serif"
          }} data-id="element-260">
              Core reset window
            </p>
          </div>
          <div className="rounded-xl p-4 text-center" style={{
          backgroundColor: '#ffffff',
          border: '1px solid rgba(201,169,110,0.15)',
          boxShadow: '0 2px 8px rgba(26,39,68,0.05)'
        }} data-id="element-261">
            <p className="text-2xl font-bold mb-1" style={{
            fontFamily: "'Playfair Display', serif",
            color: '#1a2744'
          }} data-id="element-262">
              0 tears
            </p>
            <p className="text-xs" style={{
            color: '#6b6560',
            fontFamily: "'Inter', sans-serif"
          }} data-id="element-263">
              No cry-it-out required
            </p>
          </div>
          <div className="rounded-xl p-4 text-center" style={{
          backgroundColor: '#ffffff',
          border: '1px solid rgba(201,169,110,0.15)',
          boxShadow: '0 2px 8px rgba(26,39,68,0.05)'
        }} data-id="element-264">
            <p className="text-2xl font-bold mb-1" style={{
            fontFamily: "'Playfair Display', serif",
            color: '#1a2744'
          }} data-id="element-265">
              100%
            </p>
            <p className="text-xs" style={{
            color: '#6b6560',
            fontFamily: "'Inter', sans-serif"
          }} data-id="element-266">
              Pediatric sleep science based
            </p>
          </div>
        </div>
      </div>
    </section>;
}